import { useId, useRef, useMemo } from 'react';
import { TranscriptButton } from '@pm2/element-toolbar';
import { resets } from '@ui/css';
import { printHtmlNodesToJsx } from '@utils/ast';
import { UniversalContextMenu } from '@utils/component-framework';
import { useElementSize, useLoadedImage, NoSSR, PostloadedImage } from '@utils/react';
import { usePageContext } from '../../../../context.js';
import { useTaskContext } from '../../context.js';
import { PlaceTransparentImageOnImageDropzone } from './dropzone/_input.dropzone.js';
import { backgroundImageMaxHeightInPx, wrapper, canvas, inputs, contextMenu, background } from './organism.canvas.style.js';
import { transformInputsToRelativePositions } from './util.transform-to-relative-positions.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function Canvas(props) {
  const id = useId();
  const pageContext = usePageContext();
  const context = useTaskContext();
  const imageRef = useRef(null);
  const dimensions = useElementSize(imageRef, {
    axis: "vertical",
    updateState: true,
    applyTo: imageRef
  });
  const img = useLoadedImage({
    src: props.task.backgroundImageSrc
  });
  const inputs$1 = useMemo(() => transformInputsToRelativePositions(props.task.content, img), [img, props.task.content]);
  const renderedImageHeight = dimensions.height ?? backgroundImageMaxHeightInPx;
  const scale = img ? renderedImageHeight / img.naturalHeight : 1;
  return /*#__PURE__*/jsx("div", {
    className: wrapper,
    "data-context": context,
    "data-page-context": pageContext,
    children: /*#__PURE__*/jsxs("div", {
      className: canvas,
      children: [/*#__PURE__*/jsx(NoSSR, {
        children: /*#__PURE__*/jsx("div", {
          className: inputs,
          children: inputs$1?.map(input => /*#__PURE__*/jsx(PlaceTransparentImageOnImageDropzone, {
            draggable: props.draggable,
            draggedItemId: props.draggedItemId,
            dropzone: input,
            facitType: props.facitType,
            scale: scale,
            taskEntryKey: props.taskEntryKey,
            tiles: props.task.tiles,
            settings: props.task.settings
          }, input.id))
        })
      }), !!props.task.backgroundLongDescription?.length && /*#__PURE__*/jsx("div", {
        className: contextMenu,
        children: /*#__PURE__*/jsx(UniversalContextMenu, {
          layout: "solid",
          label: "\xC5bn kontekstmenuen",
          children: /*#__PURE__*/jsx(TranscriptButton, {
            nodeType: "image-component",
            transcript: props.task.backgroundLongDescription
          }, "transcript")
        })
      }), /*#__PURE__*/jsx(PostloadedImage, {
        ref: imageRef,
        className: background,
        src: props.task.backgroundImageSrc,
        alt: props.task.backgroundAltText ?? "",
        "aria-details": props.task.backgroundLongDescription?.length ? `transcript-${id}` : undefined
      }), !!props.task.backgroundLongDescription?.length && /*#__PURE__*/jsx("div", {
        className: resets.screenReaderOnlyCls,
        id: `transcript-${id}`,
        children: printHtmlNodesToJsx(props.task.backgroundLongDescription)
      })]
    })
  });
}

export { Canvas };
//# sourceMappingURL=organism.canvas.js.map
